var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{staticClass:"status-label justify-content-center",class:{
    'status-label--tournament': _vm.forTournament,
  },attrs:{"text":_vm.badgeText,"variant":_vm.variants[_vm.status]}})}
var staticRenderFns = []

export { render, staticRenderFns }